import {useQuery} from "react-query"
import {AccessTokenInfo, UserInfo} from "dto/auth/Authentication"
import {authAxios} from "lib/http/http.common"
import {ApiResponse} from "dto/ApiResponse"

export const useFindUserInfo = (tokenInfo: AccessTokenInfo) => {
    return useQuery("findUserInfo", async () => {
        const response = await authAxios.get<ApiResponse<UserInfo>>('/auth/userinfo', {
            headers: {
                "Authorization": `Bearer ${tokenInfo.access_token}`
            }
        })
        return response.data?.body
    }, {
        enabled: !!tokenInfo.access_token
    })
}